



























import Vue from "vue";
import lockToggle from "@/components/Common/LockDeviceToggle.vue";
import actionBar from "@/components/Common/ActionBar.vue";
import deviceSelect from "@/components/Common/DeviceSelectDropDown.vue";
import Tab from "@/components/Common/Tab.vue";
import { CompanySetting } from "@/models/CompanySetting";
import { CloudSetting } from "@/models/CloudSetting";
import { CloudSettingService } from "@/services/cloudSettingService";
import { FirebaseService } from "@/services/firebaseService";
import { AuthenticationService } from "@/services/authenticationService";
import { CompanySettingService } from "@/services/companySettingService";
import { Info } from "@/models/Info";

export default Vue.extend({
  components: {
    actionBar,
    deviceSelect,
    lockToggle,
    Tab
  },
  data() {
    return {
      snapshotEventFired: {} as any,
      unsubscribeList: [] as Array<() => void>,
      loading: false,
      saving: false,
      info: {
        companySettings: [] as CompanySetting[],
        cloudSettings: [] as CloudSetting[],
        selectedDevice: null as CloudSetting | null
      } as Info
    };
  },
  mounted() {
    this.loadData();
  },
  beforeDestroy() {
    this.unSubscribeAll();
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const result1 = await CloudSettingService.getCloudSettings();
        this.info.cloudSettings = result1.cloudSettings;
        this.realtimeUpdateAllDevices(this.info.cloudSettings);
        const result2 = await CompanySettingService.getCompanySettings();
        this.info.companySettings = result2.appSettings;
        this.mixCloudAndCompanySettings(this.info.companySettings, this.info.cloudSettings);
        this.selectDevice();
      } catch (error) {
        if (error.statusCode === 401) {
          this.$router.push(`/error/${encodeURI("Unauthorized Access")}`);
        } else if (error.statusCode === 500) {
          this.$router.push(`/error/${encodeURI("Internal Server Error")}`);
        } else {
          this.$router.push(`/error/${encodeURI(error.message || error.toString())}`);
        }
      } finally {
        this.loading = false;
      }
    },
    async clone() {
      try {
        this.saving = true;
        const swalResult = await this.$swal({
          title: "Clone Device",
          icon: "info",
          text: "Device Name:",
          content: {
            element: "input"
          }
        });
        if (swalResult) {
          await CloudSettingService.cloneDevice(this.info.selectedDevice!.deviceUDID, swalResult);
          await this.loadData();
          this.selectDeviceByName(swalResult);
        }
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.saving = false;
      }
    },
    selectDevice(selectedDevice?: CloudSetting) {
      if (selectedDevice) {
        this.info.selectedDevice = selectedDevice;
      } else if (this.info.cloudSettings.length) {
        if (!this.info.selectedDevice) {
          this.info.selectedDevice = this.info.cloudSettings[0];
        } else {
          const filterResult = this.info.cloudSettings.filter(x => x.deviceUDID == this.info.selectedDevice!.deviceUDID);
          if (filterResult.length > 0) {
            this.info.selectedDevice = filterResult[0];
          } else {
            this.info.selectedDevice = this.info.cloudSettings[0];
          }
        }
      }
    },
    selectDeviceByName(deviceName: string) {
      const filterResult = this.info.cloudSettings.filter(x => x.deviceName == deviceName);
      if (filterResult && filterResult.length) {
        this.selectDevice(filterResult[0]);
      }
    },
    unSubscribeAll() {
      if (this.unsubscribeList) {
        this.unsubscribeList.forEach(unsubscribe => {
          if (unsubscribe) {
            unsubscribe();
          }
        });
      }
      this.unsubscribeList = [];
    },
    realtimeUpdateAllDevices(cloudsetting) {
      this.snapshotEventFired = {};
      this.unSubscribeAll();
      if (cloudsetting) {
        cloudsetting.forEach(device => {
          const unsubscribe = this.realtimeUpdate(AuthenticationService.parseToken(AuthenticationService.readToken()).companyId, device.deviceUDID);
          this.unsubscribeList.push(unsubscribe);
        });
      }
    },
    realtimeUpdate(companyId, deviceId) {
      return FirebaseService.getFirestoreDatabaseReference(companyId, deviceId).onSnapshot(async doc => {
        // Ignore initial snapshot.
        if (!this.snapshotEventFired[deviceId]) {
          this.snapshotEventFired[deviceId] = true;
        } else {
          try {
            this.loading = true;
            const result = await CloudSettingService.getCloudSettings(deviceId);
            this.updateCloudSetting(result.cloudSetting);
          } catch (error) {
            this.showErrorMessage(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    updateCloudSetting(cloudSetting) {
      const index = this.info.cloudSettings.findIndex(setting => setting.deviceUDID == cloudSetting.deviceUDID);
      if (index >= 0) {
        this.info.cloudSettings[index] = cloudSetting;
        this.mixCloudAndCompanySettings(this.info.companySettings, this.info.cloudSettings);
        this.selectDevice();
      }
    },
    mixCloudAndCompanySettings(companySettings: CompanySetting[], cloudSettings: CloudSetting[]) {
      if (cloudSettings) {
        cloudSettings.forEach(device => {
          device.companySettings = [];
          const keys = Object.keys(device.settings);
          const values = Object.values(device.settings);
          for (let i = 0; i < keys.length; i++) {
            const foundCompanySetting = companySettings.filter(item => item.name.toLowerCase() == keys[i].toLowerCase());
            if (foundCompanySetting && foundCompanySetting.length > 0) {
              device.companySettings.push({
                ...foundCompanySetting[0],
                stringValue: values[i]
              });
            }
          }
        });
      }
    }
  }
});
